export {default} from './ContactCard';



// WEBPACK FOOTER //
// ./src/components/ContactCard/index.js